// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/soc-frontend/" + chunkId + "." + {"4":"e7092c07","81":"d694c0ba","223":"5b17b6ac","325":"c634a6a5","495":"9538213d","682":"e68029ab","967":"7f202628"}[chunkId] + ".chunk.js";
};